module.exports = __webpack_public_path__ + "img/poster3.0920bc3d.png";